import { render, staticRenderFns } from "./subItem.vue?vue&type=template&id=5829a368&scoped=true&"
import script from "./subItem.vue?vue&type=script&lang=js&"
export * from "./subItem.vue?vue&type=script&lang=js&"
import style0 from "./subItem.vue?vue&type=style&index=0&id=5829a368&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5829a368",
  null
  
)

export default component.exports